/* eslint-disable */
// WARNING: this file is generated by a script, don't change it manually!
import { SvgIcon, SvgIconProps } from "@mui/material";
import * as React from "react";
const Loading: React.FC<SvgIconProps> = (props) => <SvgIcon {...props} data-testid="OriginLoadingIcon"><path fill="currentColor" d="M20.457 8.922c.52-.19 1.098.078 1.235.613a10.001 10.001 0 0 1-16.279 9.99 10 10 0 0 1 7.749-17.457c.548.064.89.603.77 1.142-.118.54-.652.874-1.202.823a8 8 0 1 0 7.07 6.19c-.123-.539.138-1.112.657-1.301" /></SvgIcon>;
export default Loading;